import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/filtrador.css';

function FiltradorTurnos() {
  const [turnos, setTurnos] = useState([]);
  const [filtros, setFiltros] = useState({
    fecha: '',
    estado: '',
    buscar: ''
  });
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const ITEMS_POR_PAGINA = 20;

  useEffect(() => {
    cargarTurnos();
  }, [pagina, filtros]);

  const cargarTurnos = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: pagina,
        limit: ITEMS_POR_PAGINA,
        ...(filtros.fecha && { fecha: filtros.fecha }),
        ...(filtros.estado && { estado: filtros.estado }),
        ...(filtros.buscar && { buscar: filtros.buscar })
      });

      const response = await api.get(`/turnos?${params}`);
      const { data, pagination } = response.data;

      setTurnos(data);
      setTotalPaginas(pagination.pages);
      setTotalRegistros(pagination.total);
    } catch (error) {
      console.error('Error al cargar turnos:', error);
      alert('Error al cargar turnos');
    } finally {
      setLoading(false);
    }
  };

  const manejarCambio = (campo, valor) => {
    setFiltros((prev) => ({
      ...prev,
      [campo]: valor
    }));
    setPagina(1);
  };

  const limpiarFiltros = () => {
    setFiltros({
      fecha: '',
      estado: '',
      buscar: ''
    });
    setPagina(1);
  };

  const irAPagina = (nuevaPagina) => {
    if (nuevaPagina > 0 && nuevaPagina <= totalPaginas) {
      setPagina(nuevaPagina);
    }
  };

  return (
    <div className="filtrador-container">
      <div className="filtrador-header">
        <h2>Gestión de Turnos</h2>
      </div>

      {/* Filtros */}
      <div className="filtros-section">
        <div className="filtro-grupo">
          <label>📅 Fecha:</label>
          <input
            type="date"
            value={filtros.fecha}
            onChange={(e) => manejarCambio('fecha', e.target.value)}
            className="filtro-input"
          />
        </div>

        <div className="filtro-grupo">
          <label>Estado:</label>
          <select
            value={filtros.estado}
            onChange={(e) => manejarCambio('estado', e.target.value)}
            className="filtro-select"
          >
            <option value="">Todos</option>
            <option value="pendiente">Pendiente</option>
            <option value="completado">Completado</option>
            <option value="cancelado">Cancelado</option>
          </select>
        </div>

        <div className="filtro-grupo">
          <label>🔍 Buscar Paciente:</label>
          <input
            type="text"
            placeholder="Nombre del paciente..."
            value={filtros.buscar}
            onChange={(e) => manejarCambio('buscar', e.target.value)}
            className="filtro-input"
          />
        </div>

        <button onClick={limpiarFiltros} className="btn-limpiar">
          ✕ Limpiar Filtros
        </button>
      </div>

      {loading && <p className="loading">Cargando turnos...</p>}

      {/* Tabla de Turnos */}
      <div className="turnos-tabla">
        <table>
          <thead>
            <tr>
              <th>Paciente</th>
              <th>Fecha y Hora</th>
              <th>Duración</th>
              <th>Teléfono</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {turnos.length > 0 ? (
              turnos.map((turno) => (
                <tr key={turno.id} className={`estado-${turno.estado}`}>
                  <td><strong>{turno.paciente_nombre}</strong></td>
                  <td>
                    {new Date(turno.fecha_hora).toLocaleString('es-AR')}
                  </td>
                  <td>{turno.duracion} min</td>
                  <td>{turno.paciente_telefono || '-'}</td>
                  <td>
                    <span className={`badge badge-${turno.estado}`}>
                      {turno.estado}
                    </span>
                  </td>
                  <td>
                    <button className="btn-editar">Editar</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="sin-resultados">
                  No hay turnos registrados con estos filtros
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Info y Paginación */}
      <div className="paginacion-container">
        <p className="info-registros">
          Mostrando {(pagina - 1) * ITEMS_POR_PAGINA + 1} a{' '}
          {Math.min(pagina * ITEMS_POR_PAGINA, totalRegistros)} de {totalRegistros}{' '}
          turnos
        </p>

        <div className="controles-paginacion">
          <button
            className="btn-pagina"
            onClick={() => irAPagina(pagina - 1)}
            disabled={pagina === 1}
          >
            ← Anterior
          </button>

          <span className="numero-pagina">
            Página {pagina} de {totalPaginas}
          </span>

          <button
            className="btn-pagina"
            onClick={() => irAPagina(pagina + 1)}
            disabled={pagina === totalPaginas}
          >
            Siguiente →
          </button>
        </div>
      </div>
    </div>
  );
}

export default FiltradorTurnos;
